import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { Links } from '../models/';
import { BaseServices } from './../../kuba.services';
import { BusinessLinksService } from './businessLinks.service';

@Injectable()
export class BusinessLinksListResolver {
  constructor(private backend: BusinessLinksService) { }
  resolve(route: ActivatedRouteSnapshot): Observable<Links[]> {
    
      return this.backend.getLinksByBusinessId(+route.parent?.params['bid']);
    
  }
}
@Injectable()
export class PortalBusinessLinksListResolver {
  constructor(private backend: BusinessLinksService) { }
  resolve(): Observable<Links[]> {
    return this.backend.getLinksByPortalId(BaseServices.PortalId);
  }
}

@Injectable()
export class BusinessLinksEditResolver {
  constructor(private backend: BusinessLinksService) { }
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getLinksById(+route.params['lid']);
  }
}
